<app-flow-action-card icon="volume_up" iconColor="text-blue-600" label="Spraak">
  <span class="break-words" [innerHTML]="data().value | highlightVariables"></span>
</app-flow-action-card>
